// Generated by scripts/build-ui-icons.mjs.
export { SignOut as default } from "../ui/glyphs-6";
